<template>
    <div>
        <BaseSection>
            <BaseGrid class="base-grid--filter">
                <BaseMultiselect
                    v-model="selectedCategories"
                    :label="t('actueel.filter.type.label')"
                    :inner-label="t('actueel.filter.type.placeholder')"
                    :options="categoryOptions"
                />
            </BaseGrid>
        </BaseSection>

        <a ref="focus" />
        <BaseSection
            :width="entries.length > 0 ? 'bleed' : 'page-narrow'"
            tabindex="-1"
        >
            <BaseSpinner v-if="pending" />
            <template v-else-if="entries.length > 0">
                <BaseCard
                    v-for="(item, key) in entries"
                    :key="`card-${key}`"
                    :card-item="item"
                />
            </template>
            <div v-if="!pending && !entries.length">{{ t('actueel.no_results') }}</div>
        </BaseSection>

        <BasePaginator
            :current-page="currentPage"
            :total-pages="totalPages"
            :query-param="queryParam"
            @update:current-page="updatePage($event)"
        />
    </div>
</template>

<script setup>
import { isEmpty } from 'lodash-es';
import { formatISO } from 'date-fns';
import getPages from '~/graphql/queries/getPages.graphql';

// template-refs
const focus = ref(null);

const { t } = useI18n();

const { variables: defaultVariables } = useCraftGraphql();

const { currentPage, limit, offset, queryParam } = usePaginator(10);

// category
const { options: categoryOptions, selected: selectedCategories } = await useCategory(
    'postType',
    'categorie',
    currentPage
);

// FILTER FOR GQL
const relatedToCategories = computed(() => {
    const vars = [];

    if (selectedCategories.value) {
        for (const item of selectedCategories.value) {
            vars.push({
                group: 'postType',
                slug: item,
                site: defaultVariables.site,
            });
        }
    }

    return vars;
});

const variables = computed(() => {
    const now = formatISO(Date.now(), { representation: 'date' });

    const vars = {
        ...defaultVariables,
        uri: undefined, // We don't need the URI for this query
        section: 'posts',
        limit: limit.value,
        offset: offset.value,
        now: ['or', `>= ${now}`, null],
        showHiddenEntries: false
    };

    if (!isEmpty(relatedToCategories.value)) {
        vars.showHiddenEntries = null;
        vars.relatedToCategories = relatedToCategories.value;
    }

    return vars;
});

const { data, pending } = await useLazyAsyncQuery({
    query: getPages,
    variables
});

const { totalPages, entries } = usePaginated(data, limit);

const updatePage = (page) => {
    currentPage.value = page;

    nextTick(() => {
        window.scrollTo(0, 0);
        focus.value.focus();
    });
};
</script>
